export function Table({ rows }: { rows: Array<Record<string, unknown>> }) {
  if (!rows.length) return <p className="text-sm text-gray-500">Sin datos</p>;
  
  let headers = Array.from(new Set(rows.flatMap((row) => Object.keys(row))));
  
  // Hide raw 'key' and 'value' if we have more specific columns (like 'Producto / Key')
  if (headers.includes('key') && headers.includes('value') && headers.length > 2) {
    headers = headers.filter((h) => h !== 'key' && h !== 'value');
  }

  return (
    <div className="overflow-auto rounded border border-divider">
      <table className="min-w-full text-sm bg-surface">
        <thead className="bg-surface-muted border-b border-divider">
          <tr>
            {headers.map((h) => (
              <th key={h} className="px-4 py-3 text-left font-semibold text-muted capitalize">
                {h === 'key' ? 'Concepto' : h === 'value' ? 'Total' : h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-divider/40">
          {rows.map((row, idx) => (
            <tr key={idx} className="hover:bg-surface-muted/50 transition-colors">
              {headers.map((h) => {
                const val = row[h];
                const isFalta = val === 'Falta crear receta';
                const isGanancia = h === 'Ganancia Estimada';
                
                return (
                  <td
                    key={h}
                    className={`px-4 py-3 text-[color:var(--color-text)] ${
                      isFalta ? 'text-amber-500 dark:text-amber-400 font-medium italic' : ''
                    } ${
                      isGanancia && !isFalta ? 'text-emerald-600 dark:text-emerald-400 font-bold' : ''
                    }`}
                  >
                    {String(val ?? '')}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

